(function($, d, g) {
	
	'use strict';
    var void0 = function() {};
    var lang = d.documentElement.lang;
    var ua = navigator.userAgent;
    var isSafari = ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1;
    var isPhod = ua.match(/(iPhone|iPod)/i);
    
    var currPage;
    var eventTicketsCtn;
    var ticketQtySel;
    var addCartBtn;
    var addCartProductBtn;
    var tabsBar;
    var tabsCtn;
    var getPackageTicketsListBtn;
    var prevSelectedTickets;
    var cartCtn;
    var picPreview;
    var openProductPopupBtn;
    var respDetectionSmScreen;
    var productOptionSelect;
    var removeFromCart;
    
    var updateCart = function(q, p, nofx,f) {
        var $q = $(".dynamic-qty");
        var $p = $(".cart-tickets-price");
        // var $f = $(".cart-tickets-price-fees");
        if (nofx) {
            $q.html(q);
            $p.html(formatMoney(p));
            $f.html(formatMoney(f));
        } else {
            $q.fadeOut(200, function(){
                $q.html(q);
                $q.fadeIn(200);
            });
            $p.fadeOut(200, function(){
                $p.html(formatMoney(p));
                $p.fadeIn(200);
            });
            // $f.fadeOut(200, function(){
            //     $f.html(formatMoney(f));
            //     $f.fadeIn(200);
            // });
        }
    };
    
    var sumCart = function() {
        if ($(this).closest('.event-tickets-ctn').length !== 0) {    
            var t = $(this);
            var count = 0;
            var total = 0;
            var fees = 0;
            ticketQtySel.each(function() {
                count += parseInt($(this).val());
                total += parseFloat($(this.options[this.selectedIndex]).data("value"));
                fees += parseFloat($(this.options[this.selectedIndex]).data("fees"));
            });
            if (addCartBtn.hasClass('disabled') && count !== 0) {
                addCartBtn.removeClass('disabled');
            } else if (!addCartBtn.hasClass('disabled') && count === 0) {
                addCartBtn.addClass('disabled');
            }
            updateCart(count, total,null,fees);
            tools.disableQtyBtns(t, t.val(), t.find('option:first-child').val(), t.find('option:last-child').val());
        }
    };
    

    var sessionDirectEntrance = "virtualCashierDirectEntrance";
    var checkQty = function (e, t) {
//        var t = $(this);
        var ctn = t.closest('.virtual-cash-ticket-ctn');
        var check = ctn.find('.virtual-cash-checked-icon');
        $(".virtual-cashier-continue").addClass("disabled");
        setTimeout(function () {
            if (parseInt(ctn.find('select').val()) > 0) {
                check.removeClass('hidden');
                $(".virtual-cash-step-1-warning-1").slideUp();
                if (ctn.attr("data-pass") === 'true') {
                    $(".virtual-cash-step-1-options-ctn").find("input[name='directEntrance']").prop("checked", false);
                    $(".virtual-cash-step-1-options-ctn").find("input[name='directEntrance']").attr("disabled", true);
                    $(".virtual-cash-step-1-options-ctn").find(".check-direct-entrance").addClass("disabled").addClass("fade");

                    session.save(sessionDirectEntrance, "false", function () {});

//                    checkInventory(t, ctn.attr("data-id"));
                }
            } else {
                var counter = 0;
                $(".virtual-cash-ticket-ctn[data-pass = 'true']").each(function () {
                    counter += parseInt($(this).find(".event-ticket-select").val());
                });
                if (counter === 0) {
                    $(".virtual-cash-step-1-options-ctn").find("input[name='directEntrance']").removeAttr("disabled");
                    $(".virtual-cash-step-1-options-ctn").find(".check-direct-entrance").removeClass("disabled").removeClass("fade");
                }
                check.addClass('hidden');
//                checkInventory(t, ctn.attr("data-id"));
            }
            $(".virtual-cashier-continue").removeClass("disabled");
        }, 300);
    };
    
    var addCart = function(e) {
        var t = $(this);
        var ids = "";
        var qtys = "";
        var doorPrices = "";
        var passTicketIds = "";
        var eventId = "";
        var hasError = false;
        var delay = 0;

        if (t.hasClass('change-qty-btn')) {
            // leave time to change qty before updating cart
            delay = 100;
        }

        console.log('calling facebook function AddToCart ...............');
        fbq('track', 'AddToCart');
        // fbq('trackCustom', 'EpassliveTestAddToCart');

        setTimeout(function() {
            if(t.closest(".virtual-cash-ticket-ctn").length !== 0){
                checkQty(e, t);
            }
            $(".event-one-ticket-select-qty").each(function(e){
                var t = $(this);
                var qty = t.find(".event-ticket-select").val();
                ids += t.attr("data-id") + ",";
                qtys += qty + ",";
                if(t.closest(".virtual-cash-ticket-ctn").length !== 0){
                    doorPrices += t.closest(".virtual-cash-ticket-ctn").attr("data-doorPrice")+ ",";
                }

                if (t.data('is-multiple-choices') === true) {
                    var parent = t.closest('.event-one-ticket-ctn');
                    var nbrToChoose = t.data('nbr-to-choose');
                    
                    
                    var par = parent.closest(".virtual-cash-ticket-ctn");
                    if(par.length !== 0){
                        var id = par.attr("data-id");
                        var doorPrice = par.attr("data-doorPrice") === 'true';
                        if(doorPrice){
                            parent = $(".virtual-cash-ticket-ctn[data-id = '" + id + "'][data-doorPrice = '" + !doorPrice + "']");
                        }

                    }
                    
                    var checkboxes = parent.find('.form-check-input');
                    var count = 0;
                    if (!checkboxes) {
                        handleMulTicketsChoiceMissing(e, t);
                        hasError = true;
                    } else {
                        if (parseInt(qty) !== 0) {
                            checkboxes.each(function () {
                                if ($(this).prop('checked') === true) {
                                    passTicketIds += $(this).val() + '-';
                                    count++;

                                    if (count === nbrToChoose) {
                                        passTicketIds += ',';
                                    }
                                }
                            });
                        } else {                
                            passTicketIds += "0,";                        
                        }
                    }
                    if (count !== nbrToChoose && qty > 0) {
                        handleMulTicketsChoiceMissing(e, t);
                        hasError = true;
                        if (t.closest(".virtual-cash-ticket-ctn").length !== 0) {
                            t.closest(".virtual-cash-ticket-ctn").find(".event-ticket-select").val("0");
                            t.closest(".virtual-cash-ticket-ctn").find(".change-qty-btn.minus").addClass("disabled");
                        }
                    }
                } else {
                    if (t.attr('data-is-pass') === 'true') {
                        passTicketIds += t.attr('data-pass-tickets-ids') + ',';
                    } else {
                        passTicketIds += "X,";
                    }
                }

                eventId = t.attr('data-event-id');
                t.find(".event-ticket-select").addClass("disabled");
            });

            if (!hasError) {  
                t.addClass('disabled');
                var jsessionId = getCookieValue('JSESSIONID');
                var submitCart = $('#ifsubmitCart').val();

                if (submitCart=='Submit') {
                    $('#ifoverride').val('true');
                    $('#ifticketIds').val(ids);
                    $('#ifquantitys').val(qtys);
                    $('#ifpassTicketIds').val(passTicketIds);
                    $('#ifeventId').val(eventId);
                    if(doorPrices !== ''){
                        $('#ifdoorPrices').val(doorPrices);
                    }
                    if(t.closest(".virtual-cash-ticket-ctn").length !== 0){
                        $('#ifvirtualCashier').val('true');
                    }
                    $('#ifsubmitCartForm').submit();
                } else {
                    var url = "/action/epAddCart";
                    url += "?ajax=true&override=true";
                    url += "&jsessionId="+jsessionId;
                    url += "&ticketIds="+ids;
                    url += "&quantitys="+qtys;
                    url += "&passTicketIds="+passTicketIds;
                    url += "&eventId="+eventId;
                    if(doorPrices !== ''){
                        url += "&doorPrices=" + doorPrices;
                    }
                    if(t.closest(".virtual-cash-ticket-ctn").length !== 0){
                        url += "&virtualCashier=true";
                    }
                    if (t.data('flush-cart') && t.data('flush-cart') === true) {
                        ajax('/action/epAddCart?clear=true&ajax=true&jsessionId='+jsessionId, function(response){
                            addToCartAjax(url, t); 
                        }, true);
                    } else {
                        addToCartAjax(url, t);
                    }
                }
                
            }
        }, delay);
    };
    
    var addCartProduct = function(e) {
        var t = $(this);
        var hasError = false;
        var ctn = t.closest(".product-add-to-cart-outer-ctn");
        var qty = ctn.find("select[name = 'qty']").val();         
        var eventId = t.attr("data-eid");
        var productId = t.attr("data-id");
        var optionId = ctn.find("select[name = 'option']");
        var jsessionId = getCookieValue('JSESSIONID');
                
        if (!hasError) { 
            t.addClass('disabled');
            console.log('calling facebook function product AddToCart ...............');
            fbq('track', 'AddToCart');
            // fbq('trackCustom', 'EpassliveTestAddToCart');

            var submitCart = $('#ifpsubmitCart').val();

            if (submitCart=='Submit') {
                $('#ifpoverride').val('true');
                $('#ifpproductId').val(productId);
                $('#ifpquantity').val(qty);
                $('#ifpeventId').val(eventId);
                if(optionId !== undefined){
                    $('#ifpoptionId').val(optionId.val());
                }
                $('#ifpsubmitCartForm').submit();
            } else {
                var url = "/action/epAddCart";
                url += "?ajax=true&override=true";
                url += "&jsessionId="+jsessionId;
                url += "&productId="+productId;
                url += "&quantity="+qty;
                url += "&eventId="+eventId;

                if(optionId !== undefined){
                    url += "&optionId="+optionId.val();
                }
                
                if (t.data('flush-cart') && t.data('flush-cart') === true) {
                    ajax('/action/epAddCart?clear=true&ajax=true&jsessionId='+jsessionId, function(response){
                        $('.items-from-other-page-in-cart').slideUp();
                        addToCartProductAjax(url, t, ctn, optionId, qty, productId); 
                    }, true);
                } else {
                    addToCartProductAjax(url, t, ctn, optionId, qty, productId);
                }
            }
        }
    };
    
    var addToCartProductAjax = function(url, t, ctn, option, productQty, productId) {
        ajax(url, function(response){
            if(response.indexOf("error") !== -1){                
                updateCartProduct(0);
//                $(".cart-ticket-error").slideDown();

                if (!addCartBtn.hasClass('change-qty-btn')) {
                    t.removeClass('disabled');
                } else {
                    addCartBtn.each(function() {
                        var select = $(this).closest('.qty-input-with-buttons').find('select');
                        tools.disableQtyBtns(select, select.val(), select.find('option:first-child').val(), select.find('option:last-child').val());
                    });
                }
            } else {
                t.removeClass("disabled");
//                $(".cart-ticket-error").slideUp();
                var merchQty = parseInt(response.substring(response.indexOf("/") + 1).trim());
                var qty = parseInt(response.split(':')[1].split('-')[0]) + merchQty;
                updateCartProduct((qty === "" ? 0 : qty));

                if (option !== undefined && option.length !== 0) {
                    option.find('option[value=' + option.val() + ']').data('cart', parseInt(productQty));
                    adjustAvailableProdQty(option);
                }

                var virtualCashCtn = ctn.closest('.profile-one-product-ctn');
                var virtualCashQtyCtn = virtualCashCtn.find('.virtual-cash-qty-check');
                if (virtualCashQtyCtn) {
                    var virtualCashDeliveryOptions = $('.merch-delivery-inputs-ctn');
                    if (merchQty > 0) {
                        virtualCashDeliveryOptions.slideDown();
                        virtualCashDeliveryOptions.find('.payment-process-radio').addClass('required');
                        
                        addCartLineProduct(virtualCashCtn, productQty, option, productId);
                    } else {
                        virtualCashDeliveryOptions.slideUp();
                        virtualCashDeliveryOptions.find('.payment-process-radio').removeClass('required');
                        addCartLineProduct(virtualCashCtn, productQty, option, productId);
                    }
                    updateQtysInCart();
//                    virtualCashQtyCtn.find('.qty').html(productQty);
//                    if (productQty !== '0') {
//                        virtualCashQtyCtn.fadeIn();
//                    } else {
//                        virtualCashQtyCtn.fadeOut();
//                    }
                }

                var productCtn = virtualCashCtn ? virtualCashCtn : ctn; 

                if (!productCtn.find(addCartBtn).hasClass('change-qty-btn')) {
                    productCtn.find('select[name = "qty"]').val("0");
                    productCtn.find('.change-qty-btn.minus').addClass('disabled');
                    productCtn.find('.change-qty-btn.plus').removeClass('disabled');
                    productCtn.find('.product-element-added').slideDown("fast", function () {
                        $(this).removeClass("hide");
                    });
                    t.removeClass('disabled');
                    
                    window.setTimeout(function(){
                        productCtn.find('.product-element-added').slideUp("fast",function(){
                            $(this).addClass("hide");
                        });
                    },3000);
                } else {
                    productCtn.find(addCartBtn).each(function() {
                        var select = $(this).closest('.qty-input-with-buttons').find('select');
                        select.val(0);
                        tools.disableQtyBtns(select, select.val(), select.find('option:first-child').val(), select.find('option:last-child').val());
                    });
                }
            }
        }, true);
    };
    
    var addCartLineProduct = function (virtualCashCtn, merchQty, option, productId) {
        var optionId = -1;      
        if (option !== undefined && option.length !== 0) {
            optionId = option.val();
        }
        
        if ($(".payment-process-table-row[data-productId=" + productId + "][data-optionId=" + optionId + "]").length !== 0) {
            var row = $(".payment-process-table-row[data-productId=" + productId + "][data-optionId=" + optionId + "]");
            if (merchQty === '0') {
                row.remove();
            } else {
                row.find(".table-cell-qty.hide-responsive-ph").text(merchQty);
                row.find(".table-cell-qty.hide-desktop-ph").text(merchQty + "QT");
                row.find(".table-cell-price .nowrap").text(setMoney(parseFloat(virtualCashCtn.find(".product-price").attr("data-price") * merchQty), false));
            }
        } else if (merchQty !== '0') {
            var template = $(".cart-merch-template").children().clone();
            template.attr("data-productId", productId);
            template.attr("data-optionId", optionId);
            template.find(".payment-process-delete-item-btn-ajax").on("click", removeItem);
            template.find("input[name='productId']").val(productId);
            var optionName = "";
            if (option !== undefined && option.length !== 0) {
                template.find("input[name='optionId']").val(optionId);
                optionName = " - " + option.find("option:selected").text();
            }
            template.find(".table-cell-name").text(virtualCashCtn.find(".profile-one-product-top-ctn .profile-one-product-name").text() + optionName);

            template.find(".table-cell-price-1 .nowrap").text(setMoney(parseFloat(virtualCashCtn.find(".product-price").attr("data-price")), false));
            template.find(".table-cell-qty.hide-responsive-ph").text(merchQty);
            template.find(".table-cell-qty.hide-desktop-ph").text(merchQty + "QT");
            template.find(".table-cell-price .nowrap").text(setMoney(parseFloat(virtualCashCtn.find(".product-price").attr("data-price") * merchQty), false));
            template.removeClass("template");


            $(".virtual-cash-merch-cart").removeClass("hide");
            $(".virtual-cashier-hide-on-empty").removeClass("disabled");

            $(".payment-process-table").append(template);
            $(".virtual-cash-step-2-warning-2").slideUp();
        }
        var table = $(".payment-process-table");
        var section = $(".virtual-cash-merch-cart");

        if (table.find(".payment-process-table-row:not(.template)").length === 1) {
            section.addClass("hide");
            $(".virtual-cashier-hide-on-empty").addClass("disabled");
            $(".js-form-error-message.fields").slideUp();
        }

        if (merchQty !== '0') {
            $('html, body').animate({
                scrollTop: $(".virtual-cash-merch-cart").offset().top - 90
            }, 500);
        }
    };
    
    var updateQtysInCart = function () {
        $(".virtual-cash-product").each(function () {
            var productId = $(this).attr("data-id");
            var virtualCashQtyCtn = $(this).find('.virtual-cash-qty-check');
            var table = $(".payment-process-table");
            if (table.find(".payment-process-table-row[data-productId=" + productId + "]").length !== 0) {
                var counter = 0;
                table.find(".payment-process-table-row[data-productId=" + productId + "]").each(function () {
                    counter += parseInt($(this).find(".table-cell-qty.hide-responsive-ph").text());
                });
                if (counter === 0) {
                    virtualCashQtyCtn.fadeOut();
                } else {
                    virtualCashQtyCtn.fadeIn();
                    virtualCashQtyCtn.find(".qty").text(counter);
                }

            } else {
                virtualCashQtyCtn.fadeOut();
            }

        });
    };
    
    
    //Removes an item in ajax (virtual Cashier)
    var removeItem = function () {
        var t = $(this);
        var form = t.closest("form");
        var url = form.attr("action");
        var first = true;
        var id = -1;

        form.find("input").each(function () {
            if ($(this).attr("name") !== 'pageName') {
                if (!first) {
                    url += "&";
                } else {
                    url += "?";
                }
                url += $(this).attr("name") + "=" + encodeURIComponent($(this).val());
                first = false;
                
                if($(this).attr("name") === 'productId'){
                    id = $(this).val();
                }
            }
        });
        url += "&ajax=true";
        ajax(url, function(response){
            if(response.indexOf("success") !== -1){
                var section = t.closest(".virtual-cash-merch-cart");
                var table = t.closest(".payment-process-table");
                t.closest(".payment-process-table-row").remove();
                
                if(table.find(".payment-process-table-row:not(.template)").length === 1){
                    section.addClass("hide");
                    $(".virtual-cashier-hide-on-empty").addClass("disabled");
                    var virtualCashDeliveryOptions = $('.merch-delivery-inputs-ctn');
                    virtualCashDeliveryOptions.slideUp();
                    virtualCashDeliveryOptions.find('.payment-process-radio').removeClass('required');
                    $(".js-form-error-message.fields").slideUp();
                }
                updateQtysInCart();
            }
        }, true);  
    };
    
    var updateCartProduct = function(q, nofx) {
        var $q = $(".cart-products-count");
        if (nofx) {
            $q.html(q);
        } else {
            $q.fadeOut(200, function(){
                $q.html(q);
                $q.fadeIn(200);
            });
        }
    };

    var addToCartAjax = function(url, t) {
        ajax(url, function(response){
            if(response.indexOf("error") !== -1){                
                updateCart(0, 0,null,0);
                $(".event-one-ticket-select-qty").find(".event-ticket-select").removeClass("disabled");
                $(".cart-ticket-error").slideDown();

                if (!addCartBtn.hasClass('change-qty-btn')) {
                    t.removeClass('disabled');
                } else {
                    addCartBtn.each(function () {
                        var select = $(this).closest('.qty-input-with-buttons').find('select');
                        tools.disableQtyBtns(select, select.val(), select.find('option:first-child').val(), select.find('option:last-child').val());
                    });
                }
            } else {
                $(".cart-ticket-error").slideUp();
                var qty = response.substring(response.indexOf(":") + 1, response.indexOf("-")).trim();
                var total = response.substring(response.indexOf("-") + 1, response.indexOf("/")).trim();
                updateCart((qty === "" ? 0 : qty), (total === "" ? 0 : total),null,0);
                
                $(".event-one-ticket-select-qty").find(".event-ticket-select").removeClass("disabled");

                if (!addCartBtn.hasClass('change-qty-btn')) {
                    if (qty !== '0' && qty !== '') {
                        window.location.href = addCartBtn.attr('data-forward');
                    } else {
                        if (!t.hasClass("locked")) {
                            t.removeClass('disabled');
                        }
                    }
                } else {
                    if($(".virtual-cash-resp-wrap").length !== 0){
                        checkInventory(t, t.closest(".event-one-ticket-select-qty").attr("data-id"));
                    }
                    addCartBtn.each(function() {
                        var select = $(this).closest('.qty-input-with-buttons').find('select');
                        tools.disableQtyBtns(select, select.val(), select.find('option:first-child').val(), select.find('option:last-child').val());
                    });
                }
            }
        }, true);
    };



    var checkInventory = function (t, id) {
        if ($(".virtual-cash-ticket-ctn[data-id = " + id + "]").length > 1) {
            var max = parseInt(t.attr("data-max-qty"));
            var count = 0;
            $(".virtual-cash-ticket-ctn[data-id = " + id + "]").each(function () {
                count += parseInt($(this).find(".event-ticket-select").val());
            });
            if (count === max) {
                $(".virtual-cash-ticket-ctn[data-id = " + id + "]").each(function () {
                    $(this).find(".change-qty-btn.plus").addClass("locked");
                    $(this).find(".warning-no-tickets").slideDown();
                });
            } else {
                $(".virtual-cash-ticket-ctn[data-id = " + id + "]").each(function () {
                    $(this).find(".change-qty-btn.plus").removeClass("locked");
                    $(this).find(".warning-no-tickets").slideUp();
                });
            }
        }
    };
    
    var handleMulTicketsChoiceMissing = function(e, t) {
        var errorSelectTickets = t.closest(".event-one-ticket-ctn").find('.event-details-error-select-tickets-msg');

        errorSelectTickets.addClass('open');
        setTimeout(function() {
            errorSelectTickets.removeClass('open');
        }, 5000);
        return;
    };

    var initStickyTabs = function() {
        var y1 = tabsBar.offset().top;
        if (y1 > $(window).scrollTop() && tabsCtn.hasClass("sticky")) {
            tabsCtn.removeClass("sticky");
            // tabsBar.removeAttr('style');
        }
        if (y1 <= $(window).scrollTop() && !tabsCtn.hasClass("sticky")) {
            tabsCtn.addClass("sticky");
        }
        rAF(initStickyTabs);
    };
    var setTabsBarHeight = function() {
        tabsBar.height(tabsCtn.height());
    };
    
    var initStickyCart = function() {
        var y1 = $('.profile-merch-outer-ctn').offset().top - 115 - $('.site-header').height() - $('.tabs-bar').height();
        if (y1 > $(window).scrollTop() && cartCtn.hasClass("fixed")) {
            cartCtn.removeClass("fixed");
        }
        if (y1 <= $(window).scrollTop() && !cartCtn.hasClass("fixed")) {
            cartCtn.addClass("fixed");
        }
        rAF(initStickyCart);
    };

    var popContactForm = function(e) {
        var pu = $("#" + $(this).attr("data-id"));
        if (pu.length !== 0) {
            pu.addClass("open");
            $("body .overlay").addClass("active");
        }
    };
    
    var sendContact = function(e) {
        var popup = $(this).closest('.popup-ctn');
        e.preventDefault();
        var inps = this.elements,
            data = "?personId=0&file=contact-organizer";
        
        for (var i = 0; i < inps.length; i++) {
            var inp = inps[i];
            if ($(inp).hasClass("required") && $(inp).hasClass("error")) {
                return false;
            }
            if (inp.name !== "") {
                data += "&" + inp.name + "=" + inp.value;
            }
        }
        ajax(this.action + encodeURI(data), function() {
            popup.find('.input-ctn').removeClass('focused');
            popup.find('.form-input').removeClass('success').val('');
            popup.find('.contact-message-sent-success-msg').slideDown();
            setTimeout(function() {
                $("#event-details-contact-popup").removeClass("open");
                $("body .overlay").removeClass("active");
                popup.find('.contact-message-sent-success-msg').slideUp();
            }, 5000);
        });
        
        return false;
    };

    var checkUrlContact = function() {
        var url = window.location.href;

        if (url.indexOf('contact=true') !== -1) {
            $('.profile-infos-table .popup-btn').trigger('click');
        }
    };

    var getTicketsList = function() {
        var t = $(this);
        var url = t.attr('data-url');
        var parent = t.closest('.standard-package-tickets-list');
        var ctn = parent.find('.event-folders-tickets-list');
        var tickets = parent.find('.event-details-chosen-tickets-ctn');
        var preSelectedTickets = parent.find('input[name="prev-selected-tickets"]');

        // if ajax already fetched
        if (ctn.children().length !== 0) {
            parent.find('.tickets-list-popup-btn').trigger('click');
            return;
        }

        var popup = parent.find('.event-details-tickets-list-popup');
        
        ajax(url, function(response) {
            var json = JSON.parse(response);
            $.each(json, function(k, v) {
                var eventFolderClone = parent.find('.event-folders-temp.hide').clone();
                var innerCtn = eventFolderClone.find('.tickets-list-content-ctn');
                var eventInfos = json[k];
                var eventLocation = eventInfos.name;
                var eventStartDate = ', ' + eventInfos.startDate;
                var displayEndTime = eventInfos.displayEndTime;
                var tickets = eventInfos.tickets;

                eventFolderClone.find('.tickets-list-header').html(eventInfos.eventName);
                eventFolderClone.find('.tickets-list-header-ctn').click(toggleEventTicketsList);

                $.each(tickets, function(k, v) {
                    var dateTime = '';
                    if (v.ticketStartDate !== eventInfos.startDate) {
                        eventStartDate = '';
                        if (displayEndTime === 'true') { 
                            if (lang === 'fr') {
                                dateTime += 'Du ';
                            } else {
                                dateTime += 'From ';
                            }
                        }
                    }
                    dateTime += v.ticketStartDate + ', ' + v.ticketStartTime;
                    if (displayEndTime === 'true' && v.ticketEndDate && v.ticketEndDate !== '' && v.ticketEndDate !== v.ticketStartDate) {
                        dateTime += '<br/>';
                        if (lang === 'fr') {
                            dateTime += 'Au ';
                        } else {
                            dateTime += 'To ';
                        }
                        dateTime += v.ticketEndDate;
                    }
                    if (displayEndTime === 'true' && v.ticketEndTime && v.ticketEndTime !== '') {
                        if (v.ticketEndDate && v.ticketEndDate !== '' && v.ticketEndDate !== v.ticketStartDate) {
                            dateTime += ', ';
                        } else { 
                            if (lang === 'fr') {
                                dateTime += ' à ';
                            } else {
                                dateTime += ' at ';
                            }
                        }

                        dateTime += v.ticketEndTime;
                    }

                    var ticketClone = parent.find('.event-folders-ticket-temp.hide').clone();
                    ticketClone.find('.form-check-input.package-ticket-choice').val(v.ticketId);
                    ticketClone.find('.name').html(v.ticketName);
                    if (dateTime.indexOf('undefined') === -1) {
                        ticketClone.find('.datetime').html(dateTime);
                    } else {
                        ticketClone.find('.datetime').remove();
                        ticketClone.find('.events-list-one-event-price-icon').remove();
                        ticketClone.find('.separator').remove();
                    }

                    ticketClone.find('.form-check-input.package-ticket-choice').change(updateTicketChoiceCount);
                    
                    innerCtn.append(ticketClone.children());
                });

                eventFolderClone.find('.tickets-list-subheader').html(eventLocation + eventStartDate);
                
                if (eventFolderClone.find('.tickets-list-one-ticket-ctn').length) {
                    ctn.append(eventFolderClone.children());
                }
            });

            if (!preSelectedTickets.length) {
                parent.find('.tickets-list-popup-btn').trigger('click');
            } else {
                parent.find('.form-check-input.package-ticket-choice').each(function() {
                    if (preSelectedTickets.val().indexOf($(this).val()) !== -1) {
                        $(this).trigger('click');
                    }
                });
            }
        }, true);
    };

    var toggleEventTicketsList = function() {
        $(this).closest('.event-folder-single').toggleClass('list-open');
        $(this).closest('.event-folder-single').find('.tickets-list-content-ctn').slideToggle();
    };

    var updateTicketChoiceCount = function() {
        var t = $(this);
        var ctn = t.closest('.event-one-ticket-ctn');
        var parent = t.closest('.tickets-choice-popup-content');
        var nbrLeftToChoose = parent.data('nbr-left');

        if (t.prop('checked') && nbrLeftToChoose > 0) {
            nbrLeftToChoose--;
            parent.find('.count').html(nbrLeftToChoose);
            parent.data('nbr-left', nbrLeftToChoose);
            updateTicketChoiceList(ctn, t.val(), t.closest('.tickets-list-one-ticket-content').find('.name').html(), 'add');
        } else if (!t.prop('checked')) {
            nbrLeftToChoose++;
            parent.find('.count').html(nbrLeftToChoose);
            parent.data('nbr-left', nbrLeftToChoose);
            updateTicketChoiceList(ctn, t.val(), null, 'remove');
        }

        if (nbrLeftToChoose === 0) {
            parent.find('.form-check-input').each(function() {
                if (!$(this).prop('checked')) {
                    $(this).closest('.tickets-list-one-ticket-content').addClass('disabled');
                }
            });
        } else if (parent.find('.tickets-list-one-ticket-content.disabled').length > 0) {
            parent.find('.form-check-input').each(function() {
                if (!$(this).prop('checked')) {
                    $(this).closest('.tickets-list-one-ticket-content').removeClass('disabled');
                }
            });
        }
    };

    var updateTicketChoiceList = function(ctn, id, name, type) {
        var selectTicketsText = ctn.find('.get-package-tickets-list.multiple:not(.icon)');
        var listOuterCtn = ctn.find('.event-details-chosen-tickets-outer-ctn');
        var listCtn = ctn.find('.event-details-chosen-tickets-ctn');
        var oneEvent = ctn.find('.event-details-one-chosen-ticket.hide').clone();
        
        var par = ctn.closest(".virtual-cash-ticket-ctn");
        var id = par.attr("data-id");
        var doorPrice = par.attr("data-doorPrice") === 'true';
        var other = $(".virtual-cash-ticket-ctn[data-id = '" + id + "'][data-doorPrice = '" + !doorPrice + "']");
        var selectTicketsText2 = other.find('.get-package-tickets-list.multiple:not(.icon)');
        var listOuterCtn2 = other.find('.event-details-chosen-tickets-outer-ctn');
        var listCtn2 = other.find('.event-details-chosen-tickets-ctn');
        
        if (type === 'add') {
            oneEvent.html(name);
            oneEvent.attr('data-id', id);
            listCtn.append(oneEvent.removeClass('hide'));
            if(listOuterCtn.css('display') !== 'block') {
                selectTicketsText.slideUp(function() {
                    listOuterCtn.slideDown();
                });
            }
            if(par.length !== 0){
                var oneEvent2 = oneEvent.clone();
                if($(".virtual-cash-ticket-ctn[data-id = '"+id+"']").length > 1){
                    listCtn2.append(oneEvent2.removeClass('hide'));
                    if (listOuterCtn2.css('display') !== 'block') {
                        selectTicketsText2.slideUp(function () {
                            listOuterCtn2.slideDown();
                        });
                    }
                }
            }
        } else {
            listCtn.find('.event-details-one-chosen-ticket[data-id=' + id + ']').remove();

            if(!listOuterCtn.find('.event-details-one-chosen-ticket:not(.hide)').length) {
                listOuterCtn.slideUp(function() {
                    selectTicketsText.slideDown();
                });
            }
            if(par.length !== 0){
                if($(".virtual-cash-ticket-ctn[data-id = '"+id+"']").length > 1){
                    listCtn2.find('.event-details-one-chosen-ticket[data-id=' + id + ']').remove();

                    if (!listOuterCtn2.find('.event-details-one-chosen-ticket:not(.hide)').length) {
                        listOuterCtn2.slideUp(function () {
                            selectTicketsText2.slideDown();
                        });
                    }
                }
            }
        }
    };

    var displaySelectedPic = function() {
        var t = $(this);
        var ctn = t.closest('.one-product-available-pictures');
        var activePicCtn = t.closest('.one-product-popup-pictures-ctn').find('.one-product-active-picture');
        var imgUrl = t.css('background-image');

        ctn.find(picPreview).removeClass('active');
        t.addClass('active');
        activePicCtn.fadeOut(300, function() {
            $(this).css('background-image', imgUrl);
            $(this).fadeIn(300);
        });
    };

    var scrollTopAllProducts = function() {
        if ($(window).scrollTop() > $('.tabs-content').offset().top - 70 && respDetectionSmScreen.css('visibility') !== 'visible') {
            var pos = $('.tabs-content').offset().top - 70;
            pageScrlTo(pos);
        }
    };

    var getMaxAllowed = function(option) {
        var available = option.data('available');
        var max = option.data('max');

        var maxAvailable = available > max ? max : available;
        
        return maxAvailable;
    };

    var adjustAvailableProdQty = function(select) {
        var t = $(this).length > 0 ? $(this) : select;
        var option = t.find('option[value=' + t.val() + ']');
        var product = t.closest('.profile-one-product-ctn');
        var plusBtn = product.find('.change-qty-btn.plus');
        var productQtySelect = product.find('.event-product-select');
        
        var maxAllowed = getMaxAllowed(option);
        var count = 0;

        plusBtn.data('max-qty', maxAllowed);

        if (productQtySelect.val() > maxAllowed) {
            productQtySelect.val(maxAllowed);
        } else if (productQtySelect.val() < maxAllowed) {
            plusBtn.removeClass('disabled');
        }

        product.find('.event-product-select').find('option').each(function() {
            $(this).val() > maxAllowed ? $(this).addClass('hide') : $(this).removeClass('hide');
        });
    };

    var getCookieValue = function(name) {
        const nameEQ = name + "=";
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length, cookie.length);
            }
        }
        return null;
    }

	var init = function (page) {
        
        // check if cookie enabled in browser
        const isCookieEnabled = navigator.cookieEnabled;
        if (!isCookieEnabled) {
            $(".please-enable-cookie").trigger("click");
        }

        currPage = page || $(".page");
        eventTicketsCtn = $(".event-tickets-ctn");
        ticketQtySel = $(".event-ticket-select");
        //Fix an issue with safari on ipad by adding blur event on <select>
        ticketQtySel.on("change" + (isSafari && isPhod ? " blur" : ""), sumCart);
        addCartBtn = $(".add-to-cart-btn");
        addCartBtn.on("click", addCart);
        addCartProductBtn = $(".product-add-to-cart-btn");
        addCartProductBtn.on("click", addCartProduct);
        prevSelectedTickets = $('input[name="prev-selected-tickets"]');
        openProductPopupBtn = $('.profile-one-product-details-btn');
        respDetectionSmScreen = $('.responsive-detector-sm');
        productOptionSelect = $('.product-option-select');
        
        getPackageTicketsListBtn = $('.get-package-tickets-list');
        getPackageTicketsListBtn.click(getTicketsList);

        tabsBar = $(".tabs-bar.profile");
        tabsCtn = tabsBar.find(".tabs-bar-items-ctn");
        if (tabsCtn.length > 0) {
            // setTabsBarHeight();
            // $(g).on("resize", setTabsBarHeight);
            initStickyTabs();
        }

        cartCtn = $('.products-cart-ctn');
        if (cartCtn.length > 0) {
            initStickyCart();
        }

        picPreview = $('.one-product-preview-pic');
        picPreview.click(displaySelectedPic);

        checkUrlContact();
        
        $(".event-details-description-table-contact-btn").on("click", popContactForm);
        $("#event-details-contact-form").on("submit", sendContact);

        prevSelectedTickets.each(function() {
            $(this).closest('.standard-package-tickets-list').find('.get-package-tickets-list:not(.icon)').trigger('click');
        });

        openProductPopupBtn.click(scrollTopAllProducts);
        productOptionSelect.click(adjustAvailableProdQty);
        
        
		removeFromCart = $('.payment-process-delete-item-btn-ajax');
		removeFromCart.click(removeItem);

        var eventId=$(".event-one-ticket-select-qty").data("event-id");
        if(eventId === 6942) { //ERIC LAPOINTE EN FORMULE SOUPER SPECTACLE
            console.log('calling facebook function ............... ERIC LAPOINTE EN FORMULE SOUPER SPECTACLE');
            fbq('init', '438706678514426');
            fbq('track', 'PageView');
        }
        if(eventId === 7165) { //OBSKUR #004 - Kill The Noise & Friends
            console.log('calling facebook function ............... OBSKUR #004 - Kill The Noise & Friends');
            fbq('init', '943675224110997');
            fbq('track', 'PageView');
        }
        if(eventId === 7325) { //Thuwan_Test_2_Event_1
            console.log('calling facebook function ............... Thuwan_Test_2_Event_1');
            fbq('init', '266548857543903');
            fbq('trackCustom', 'EpassliveTestPageView');
        }
        if(eventId === 7362) { //Thuwan_Test_2_Event_2
            console.log('calling facebook function ............... Thuwan_Test_2_Event_2');
            fbq('init', '1722681941873874');
            fbq('trackCustom', 'EpassliveTestPageView');
        }
	};
		
	$(g).on("load", function() {
        init();
    });
	
})(jQuery, document, window);